import type { ReactNode } from "react";
import { resolveSectionBannerIconSrc } from "./sectionBannerIconSrc.util";

interface SectionBannerProps {
  /** Section heading text or markup (e.g. an explicit line break). */
  title: ReactNode;
  /** Reference id for a preloaded `<symbol>` (e.g. `#icon_relationship_engine`). */
  iconHref?: string;
  /** Custom icon node — overrides `iconHref` when provided. */
  icon?: ReactNode;
  /** Bottom padding in px. Defaults to 32. */
  pb?: number;
}

/**
 * Shared centered section banner: icon + serif title + trailing `r` mark.
 * Extracted from the repeated block that appeared at the top of each
 * report section (Member Engagement, HARP Enrollment, etc.).
 * @param props - Title, optional icon, and bottom padding.
 */
const SectionBanner = ({ title, iconHref, icon, pb = 32 }: SectionBannerProps) => {
  const iconSrc = iconHref ? resolveSectionBannerIconSrc(iconHref) : undefined;

  return (
  <div className="banner" style={{ padding: `0 0 ${pb}px` }}>
    <div className="banner__inner">
      {icon ? (
        icon
      ) : iconSrc ? (
        <img
          className="banner__icon banner__icon-img"
          src={iconSrc}
          alt=""
          aria-hidden
          loading="eager"
          decoding="sync"
        />
      ) : iconHref ? (
        <svg
          className="banner__icon banner__icon-svg"
          aria-hidden="true"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid meet"
        >
          <use href={iconHref} />
        </svg>
      ) : null}
      <h2
        className="banner__title"
      >
        {title}
      </h2>
      <div className="banner__r-mark">r</div>
    </div>
  </div>
  );
};

export default SectionBanner;
